export const MANDATORY_ERROR = 'Mandatory field';
export const MANDATORY_FIELD_ERROR = '{valuePlaceholder} is a mandatory field';
export const MINLENGTH_ERROR = 'Min length is {valuePlaceholder} characters';
export const MAXLENGTH_ERROR = 'Max length is {valuePlaceholder} characters';
export const MINLENGTH_ERROR_WITH_FIELD = '{fieldName} min length is {valuePlaceholder} characters';
export const MAXLENGTH_ERROR_WITH_FIELD = '{fieldName} max length is {valuePlaceholder} characters';
export const NUMBER_ERROR_WITH_FIELD = '{valuePlaceholder} should be a number';
export const MIN_ERROR = 'Value should be greater than or equal to {valuePlaceholder}';
export const MIN_ERROR_WITH_FIELD = '{fieldName} should be greater than or equal to {valuePlaceholder}';
export const MAX_ERROR = 'Value should be less than or equal to {valuePlaceholder}';
export const PATTERN_ERROR = 'Value does not match expected pattern';
export const EMAIL_FORMAT_ERROR = 'Please verify the email is in a valid format';
export const NO_SPECIAL_CHARS_ERROR = 'Should not have special characters';
export const PASSWORD_MATCH_ERROR = 'Password confirmation doesn\'t match';
export const PASSWORD_VALIDATION_ERROR = 'Must contain 8-20 characters, including letters and special characters';
export const NUMBER_ERROR = 'Value should be a number';
export const UNIQUE_ERROR = '{valuePlaceholder} must be unique';
export const VERSION_FORMAT_ERROR = 'Please verify the version is in a valid format';
export const DATE_FORMAT_ERROR = 'This should be a valid date YYYY-MM-DD';
export const NUMBER_BETWEEN_ERROR = '{fieldName} should be between {valuePlaceholder}';

/**
 * returns a formatted error message
 * @param {String} errorMessage
 * @param {String} value
 * @param {String} fieldName
 * @returns {String}
 */
export const getErrorMessageForValue = (errorMessage, value, fieldName = '') => errorMessage
    .replace('{valuePlaceholder}', value)
    .replace('{fieldName}', fieldName);

export const getHttpErrorMessage = (errorMessage) => errorMessage || 'Something went wrong, Please refresh the page and try again.';
